import { h } from 'preact';
import { getLazyComponent } from '../../lib/Route';

const AsyncRoute = ({ routeType, ...rest }) => {
  const Comp = getLazyComponent(routeType);

  // Preact renders h(undefined, props) as a text node, i.e. "[object Object]" until
  // the route's chunk resolves. The loader in App covers this state.
  if (!Comp) {
    return null;
  }

  return <Comp {...rest} />;
};

export default AsyncRoute;
